import { manufacturerSaga as internalManufacturerSaga } from '@client/manufacturer/redux/manufacturer/sagas';
import { manufacturersSaga } from '@client/manufacturer/redux/manufacturers/sagas';
import { all, AllEffect, fork, ForkEffect } from 'redux-saga/effects';

export function* manufacturerSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([fork(internalManufacturerSaga), fork(manufacturersSaga)]);
}
